export default "__VITE_ASSET__BePxHHCg__"